/* ============================================================
   FRAISE NOIRE — PANIER SHOPIFY
   Remplace le panier localStorage de la V2 statique.

   Pourquoi ce fichier existe : dans la V2, le panier n'etait qu'un tableau
   dans le navigateur. Rien de ce qu'il contenait n'arrivait a Shopify, donc
   aucune commande n'etait possible. Ici, la seule source de verite est le
   panier Shopify, interroge et modifie par l'API Cart.

   Il s'installe EN CAPTURE et arrete l'evenement : home.js, qui ecoute en
   bouillonnement, ne voit jamais ces clics et ne peut plus ecrire sa version
   locale du panier par-dessus celle du serveur.
   ============================================================ */
(() => {
  'use strict';

  const CFG = window.FN_SHOP || {};
  const R = CFG.routes || {};
  const $ = s => document.querySelector(s);
  const $$ = s => Array.from(document.querySelectorAll(s));

  let panier = CFG.cart || { items: [], item_count: 0, total_price: 0 };
  let enCours = false;

  const eur = c => (c / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g,
    c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  async function appel(url, corps) {
    const r = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(corps)
    });
    const d = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(d.description || d.message || `HTTP ${r.status}`);
    return d;
  }

  async function relire() {
    const r = await fetch(R.cart || '/cart.js', { headers: { 'Accept': 'application/json' } });
    panier = await r.json();
    rendre();
    document.dispatchEvent(new CustomEvent('fn:panier', { detail: panier }));
    return panier;
  }

  /* ---------- resolution handle + taille -> variante ----------
     Les boutons de la V2 portent data-add="<handle>" data-size="<taille>".
     Shopify n'ajoute au panier que par identifiant de variante : on fait la
     correspondance via le catalogue genere par snippets/catalogue.liquid. */
  function variantePour(handle, taille) {
    const p = (window.FN_PRODUCTS || []).find(x => x.handle === handle);
    if (!p || !p.variants || !p.variants.length) return null;
    if (taille) {
      const v = p.variants.find(x => x.title === taille);
      // Une taille demandee mais introuvable ou epuisee ne doit pas retomber
      // silencieusement sur une autre : le client recevrait la mauvaise.
      return v && v.available ? v : null;
    }
    if (p.variants.length === 1) return p.variants[0].available ? p.variants[0] : null;
    return null;   // plusieurs tailles : il faut en choisir une
  }

  /* ---------- operations ---------- */
  async function ajouter(handle, taille) {
    const p = (window.FN_PRODUCTS || []).find(x => x.handle === handle);

    /* Ajout en un clic sans choix possible : quand la piece existe en
       plusieurs versions (les quatre casquettes declinees en couleurs, par
       exemple) et qu'aucune n'a ete designee, on ne peut pas choisir a la place
       du client. Lui repondre « Choisis une taille » devant une vitrine qui
       n'en propose aucune est une impasse : on l'emmene sur la fiche, ou le
       choix existe. */
    const choix = p && (p.variants || []).filter(x => x.available);
    if (!taille && choix && choix.length > 1) {
      location.href = (p.url || '/products/' + handle);
      return;
    }

    const v = variantePour(handle, taille);
    if (!v) { signaler(taille ? 'Cette taille n\'est plus disponible.' : 'Choisis une taille.'); return; }
    await appel(R.cartAdd || '/cart/add.js', { items: [{ id: v.id, quantity: 1 }] });
    await relire();
    ouvrir();
  }

  // `cle` est la ligne Shopify (item.key), pas un index : un index se decale
  // des qu'une ligne disparait, et on modifierait alors la mauvaise ligne.
  async function definirQte(cle, qte) {
    await appel(R.cartChange || '/cart/change.js', { id: cle, quantity: Math.max(0, qte) });
    await relire();
  }

  /* ---------- rendu ---------- */
  function rendre() {
    const n = panier.item_count || 0;

    $$('[data-cart-count]').forEach(e => {
      e.textContent = n;
      e.hidden = n === 0;
    });
    /* Ce libelle se pose APRES le mot « Panier » (tiroir et page panier) :
       « Panier vide » y donnait « Panier Panier vide ». */
    /* TOUS les exemplaires, pas le premier : sur la page panier, le tiroir et
       la page portent les memes marqueurs. En ne traitant que le premier
       trouve, le tiroir s'ouvrait VIDE au-dessus d'un panier rempli, avec
       « Panier (0) » et la barre de livraison a zero. */
    $$('[data-cart-count-txt]').forEach(e => {
      e.textContent = n === 0 ? 'vide' : `${n} article${n > 1 ? 's' : ''}`;
    });
    $$('[data-cart-sub]').forEach(e => { e.textContent = eur(panier.total_price || 0); });
    $$('[data-cart-empty]').forEach(e => { e.hidden = n > 0; });

    /* Panier vide : la barre « plus que 80 € pour la livraison offerte » n'a
       rien a mesurer, et elle s'affichait au-dessus d'un panier sans article.
       Le pied (sous-total, paiement) n'a pas davantage de sens. */
    $$('.drawer__ship').forEach(e => { e.hidden = n === 0; });
    $$('.cartpage__foot').forEach(e => { e.hidden = n === 0; });

    /* Ce que le client a ECRIT. Une casquette personnalisee est fabriquee a la
       commande : sans ce texte sous la ligne, ni lui ni l'atelier ne peuvent
       relire la configuration avant de payer (demande de Hedy, 2026-10-07).
       Les proprietes techniques (prefixe `_`) et les valeurs vides sont
       ecartees ; tout le reste s'affiche, quel que soit son nom. */
    const perso = l => Object.entries(l.properties || {})
      .filter(([k, v]) => k && k[0] !== '_' && String(v).trim())
      .map(([k, v]) => `<p class="citem__perso"><span>${esc(k)}</span> ${esc(v)}</p>`)
      .join('');

    const lignes = (panier.items || []).map(l => `
        <li class="citem">
          <a class="citem__media" href="${esc(l.url)}">
            ${l.image ? `<img src="${esc(l.image)}" alt="${esc(l.product_title)}" loading="lazy" width="80" height="107">` : ''}
          </a>
          <div class="citem__body">
            <a class="citem__name" href="${esc(l.url)}">${esc(l.product_title)}</a>
            ${l.variant_title && l.variant_title !== 'Default Title'
              ? `<p class="citem__opt">${esc(l.variant_title)}</p>` : ''}
            ${perso(l)}
            <p class="citem__price tabular">${eur(l.final_line_price)}</p>
            <div class="citem__qty">
              <button data-ligne="${esc(l.key)}" data-delta="-1" aria-label="Retirer un exemplaire">&minus;</button>
              <span>${l.quantity}</span>
              <button data-ligne="${esc(l.key)}" data-delta="1" aria-label="Ajouter un exemplaire">+</button>
            </div>
            <button class="citem__rm" data-ligne="${esc(l.key)}" data-delta="0">Retirer</button>
          </div>
        </li>`).join('');
    $$('[data-cart-items]').forEach(e => { e.innerHTML = lignes; });

    majFranco();
  }

  /* Le seuil de livraison offerte est une donnee commerciale : il est lu sur
     le marqueur pose par le theme, jamais code en dur ici. */
  function majFranco() {
    const blocs = $$('[data-ship-msg]');
    if (!blocs.length) return;
    /* Un seuil a 0 signifie « livraison offerte sans minimum » (choix de Hedy,
       2026-10-07) : plus de compte a rebours, plus de barre a remplir — la
       barre est pleine et le message est une bonne nouvelle, pas une condition. */
    const seuil = parseInt(blocs[0].dataset.seuil || '0', 10);
    if (!seuil) {
      blocs.forEach(b => { b.textContent = 'Livraison offerte.'; });
      $$('[data-ship-bar]').forEach(b => { b.style.width = '100%'; });
      return;
    }
    const reste = seuil - (panier.total_price || 0);
    const texte = reste > 0
      ? `Plus que ${eur(reste)} pour la livraison offerte.`
      : 'Livraison offerte.';
    blocs.forEach(b => { b.textContent = texte; });
    const largeur = Math.min(100, ((panier.total_price || 0) / seuil) * 100) + '%';
    $$('[data-ship-bar]').forEach(b => { b.style.width = largeur; });
  }

  function signaler(msg) {
    const z = $('[data-cart-msg]');
    if (z) { z.textContent = msg; z.hidden = false; setTimeout(() => { z.hidden = true; }, 4000); }
    else console.warn('[panier]', msg);
  }

  function ouvrir() {
    const d = $('[data-cart]');
    if (!d) { location.href = R.cart || '/cart'; return; }
    d.classList.add('open');
    d.setAttribute('aria-hidden', 'false');
    d.removeAttribute('inert');
    const fond = $('[data-cart-backdrop]');
    if (fond) { fond.hidden = false; requestAnimationFrame(() => fond.classList.add('show')); }
    const fermer = d.querySelector('[data-cart-close]');
    if (fermer) fermer.focus();
  }

  /* ---------- interception ----------
     Phase de CAPTURE : on passe avant home.js et on coupe la propagation,
     sinon les deux paniers coexisteraient et se contrediraient. */
  document.addEventListener('click', async e => {
    const ajout = e.target.closest('[data-add]');
    const ligne = e.target.closest('[data-ligne]');
    if (!ajout && !ligne) return;

    e.preventDefault();
    e.stopPropagation();
    if (enCours) return;             // un double-clic ne doit pas ajouter deux fois
    enCours = true;

    const cible = ajout || ligne;
    cible.setAttribute('aria-busy', 'true');
    try {
      if (ajout) {
        await ajouter(ajout.dataset.add, ajout.dataset.size || '');
      } else {
        const d = parseInt(ligne.dataset.delta, 10);
        const item = (panier.items || []).find(x => x.key === ligne.dataset.ligne);
        if (!item) return;
        await definirQte(ligne.dataset.ligne, d === 0 ? 0 : item.quantity + d);
      }
    } catch (err) {
      signaler(err.message || 'Le panier n\'a pas pu être mis à jour.');
    } finally {
      cible.removeAttribute('aria-busy');
      enCours = false;
    }
  }, true);

  /* ---------- fiche produit ----------
     Le formulaire fonctionne sans JavaScript (POST /cart/add classique). On
     l'intercepte seulement pour eviter le rechargement et ouvrir le tiroir ;
     si quoi que ce soit echoue ici, on laisse le navigateur poster le
     formulaire plutot que de bloquer la vente. */
  const form = document.getElementById('form-produit');
  if (form) {
    form.addEventListener('submit', async e => {
      if (enCours) { e.preventDefault(); return; }

      /* Taille obligatoire — comportement de la V2.
         Aucune taille n'est pre-cochee : le champ cache porte la premiere
         disponible pour que l'envoi sans JavaScript marche, mais tant que le
         client n'a rien choisi, l'ajout doit etre refuse. Sinon il commande
         une taille qu'il n'a jamais designee.
         Le refus doit CONDUIRE quelque part : la grille est hors ecran quand on
         achete depuis la barre collante, la faire trembler la-bas ne dit rien a
         personne. On ramene donc la vue dessus avant de la signaler. */
      const grilles = [...form.querySelectorAll('.pdp__sizegrid')];
      const champCache = form.querySelector('[data-variant-id]');
      const incomplet = grilles.some(g => !g.querySelector('.pdp__size.is-sel'))
                     || (grilles.length > 0 && (!champCache || !champCache.value));
      const grille = grilles[0];
      if (grille && incomplet) {
        e.preventDefault();
        const aSignaler = grilles.find(g => !g.querySelector('.pdp__size.is-sel')) || grille;
        const r = aSignaler.getBoundingClientRect();
        if (r.bottom < 0 || r.top > innerHeight) {
          aSignaler.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
        aSignaler.classList.remove('shake'); void aSignaler.offsetWidth; aSignaler.classList.add('shake');
        /* Le message nomme ce qui manque : sur une piece declinee en couleur
           ET en taille, « choisis ta taille » devant une couleur non choisie
           envoie chercher au mauvais endroit. */
        const manque = grilles.find(g => !g.querySelector('.pdp__size.is-sel')) || grille;
        const bloc = manque.closest('.pdp__sizes');
        const nom = bloc ? (bloc.querySelector('.pdp__sizehead .label') || {}).textContent : '';
        const msg = nom ? 'Choisis : ' + nom.trim().toLowerCase() : 'Choisis ta taille';
        if (window.FN_TOAST) window.FN_TOAST(msg);
        else signaler(msg + '.');
        return;
      }

      const champ = form.querySelector('[data-variant-id]');
      if (!champ || !champ.value) return;        // sans id : envoi natif

      e.preventDefault();
      enCours = true;
      const bouton = form.querySelector('[name="add"]');
      if (bouton) { bouton.setAttribute('aria-busy', 'true'); bouton.disabled = true; }
      try {
        /* Les champs `properties[...]` du formulaire suivent la ligne jusqu'a la
           commande. Sans eux, une casquette personnalisable partait SANS son
           lettrage des qu'on l'ajoutait depuis la fiche (2026-10-07).
           Un champ vide n'est pas envoye : mieux vaut pas de propriete du tout
           qu'une ligne « Personnalisation : » vide dans le panier.
           Pour le lettrage, on reprend la formulation du configurateur de
           l'accueil — « Flex « X » · abeille rose » — pour que l'atelier lise
           la meme chose quelle que soit la porte d'entree. */
        const props = {};
        form.querySelectorAll('[name^="properties["]').forEach(ch => {
          const nom = ch.name.slice(11, -1);
          const val = (ch.value || '').trim();
          if (!val) return;
          if (ch.hasAttribute('data-perso-flex')) {
            const coul = (form.querySelector('.pdp__size.is-sel') || {}).textContent || '';
            props[nom] = coul.trim()
              ? `Flex « ${val} » · abeille ${coul.trim().toLowerCase()}`
              : `Flex « ${val} »`;
          } else {
            props[nom] = val;
          }
        });
        const ligne = { id: Number(champ.value), quantity: 1 };
        if (Object.keys(props).length) ligne.properties = props;
        await appel(R.cartAdd || '/cart/add.js', { items: [ligne] });
        await relire();
        ouvrir();
      } catch (err) {
        signaler(err.message || 'Cette piece n\'a pas pu etre ajoutee.');
      } finally {
        if (bouton) { bouton.removeAttribute('aria-busy'); bouton.disabled = false; }
        enCours = false;
      }
    });

    /* Changer de taille change la variante, son prix ET le marquage visuel.
       Les trois doivent suivre ensemble : la classe is-sel est posee par Liquid
       sur la variante initiale et ne bouge pas toute seule. Sans ce
       deplacement, on tape « Cameleon », le panier recoit bien Cameleon, mais
       l'ecran continue de montrer « Full Black » entoure — le client croit
       choisir une couleur et en voit une autre marquee. */
    form.addEventListener('change', e => {
      const radio = e.target.closest('[data-variant]');
      if (!radio) return;

      const champ = form.querySelector('[data-variant-id]');
      if (champ) champ.value = radio.dataset.variant;

      const etiquette = form.querySelector(`label[for="${radio.id}"]`);
      form.querySelectorAll('.pdp__size').forEach(l => l.classList.remove('is-sel'));
      if (etiquette) etiquette.classList.add('is-sel');

      const prix = document.querySelector('[data-prix]');
      if (etiquette && prix && etiquette.dataset.prixVariante) {
        prix.textContent = etiquette.dataset.prixVariante;
      }
    });
  }

  /* API publique, pour les pages produit et les tests. */
  window.FN_CART = {
    get: () => panier,
    relire,
    ajouter,
    definirQte,
    ouvrir,
    variantePour
  };

  document.addEventListener('DOMContentLoaded', rendre);
  if (document.readyState !== 'loading') rendre();
})();
